const trimStrings = (value: unknown): unknown => {
    if (typeof value === 'string') {
        return value.trim();
    }
    if (Array.isArray(value)) {
        return value.map(trimStrings);
    }
    if (value !== null && typeof value === 'object') {
        return Object.fromEntries(
            Object.entries(value).map(([key, entry]) => [
                key,
                trimStrings(entry)
            ])
        );
    }
    return value;
};

export const withTrimmedJsonBody = (
    init?: RequestInit
): RequestInit | undefined => {
    const headers = init?.headers as Record<string, string> | undefined;
    if (
        typeof init?.body !== 'string' ||
        headers?.['Content-Type'] !== 'application/json'
    ) {
        return init;
    }
    return {
        ...init,
        body: JSON.stringify(trimStrings(JSON.parse(init.body)))
    };
};
